module.exports = __webpack_public_path__ + "img/side seam back pocket position.8b0f1c88.png";